module.exports = __webpack_public_path__ + "img/spike_banner.c69b270a.png";